// urls
export const CDN_URL =
  process.env.NEXT_PUBLIC_CDN_URL ||
  'https://storage.googleapis.com/beek-web-cdn';
export const IMAGE_CDN_URL =
  process.env.NEXT_PUBLIC_IMAGE_CDN_URL || 'https://nicephore.beek.io';
